import { replaceWithCdnUrl } from '@/utils/cdnHelper'

export function resolvePhotoUrl(photo) {
  const a = photo.attributes
  const url =
    (typeof a.image === 'string' && a.image) ||
    a.edited_image_url ||
    a.original_image_url ||
    a.edited_file_url ||
    a.original_file_url ||
    ''
  return replaceWithCdnUrl(url) || url
}

export function resolveThumbUrl(photo) {
  const a = photo.attributes
  const url =
    a.video_thumb ||
    a.photo ||
    a.original_file_thumb_url ||
    resolvePhotoUrl(photo)
  return replaceWithCdnUrl(url) || url
}
